// extracted by mini-css-extract-plugin
export default {"warp":"preset_apps_warp__BLPkf","home_title":"preset_apps_home_title__z9nYC","foot":"preset_apps_foot__VR4Gc"};